 const  advanceHelp = {
    'cn':[
        {
            'title':`1、如何经营你的人生`,
        },
        {
            'content':[`下一年：点击后会进入下一年，并且结算一年的收益，随着年龄越大，下一年也将会扣除更多的健康值`]
        },
        {
            'content':[` 总部：你公司的基本信息，可通过升级公司来获得更多的能力。`]
        },
        {
            'content':[` 产业：公司的核心，创业期一定要优先投资产业，可获得的巨大的财富，也是能力属性的主要产出。`]
        },
        {
            'content':[` 房产：可购置房产来增加名气，房资产将会在聚会类事件中发挥作用。`]
        },
        {
            'content':[` 车库：可购置汽车来增加名气，车资产将会在聚会类事件中发挥作用。`]
        },
        {
            'title':`2、如何合理投资`,
        },
        {
            'content':[`风险投资：用现金投资项目，当到期后可收获投资回报，实际收益会根据对应投资项目的收益范围与自身的智商计算得出。`]
        },
        {
            'content':[` 股市：每年股市的价格都会浮动，你可以在低价时买入，在高价时抛出来赚取现金`]
        },
        {
            'content':[` 收购：当你有闲余的资金后，可以在这里收购公司，被收购的公司每年将会给你带来现金分红收益。`]
        },
        {
            'content':[` 百亿项目：当你的现金超过百亿后就可以来该功能进行超级投资，每年将会有数亿的分红等着你。`]
        },
        {
            'title':`3、如何建立团队`,
        },
        {
            'content':[`多多关注自己的员工列表、团队加成属性、人数和总年薪。`]
        },
        {
            'content':[` （1）招聘：在招聘市场可以找到你要的员工，可通过刷新找到更多的人。`]
        },
        {
            'content':[` （2）挖人：这里是猎聘市场，通过猎头可以将已经有工作的人猎到你的公司，但需要支付一定的跳槽费用。`]
        },
        {
            'title':`4、如何参加活动`,
        },
        {
            'content':[`（1）参加活动可以获得额外的现金收益，和四维属性的加成哦！`]
        },
        {
            'content':[`（2）每参加一个活动将会消耗20点体力值，每年你都会有100点体力值，别忘记用哦。`]
        },
    ],
    'en':[
        {
            'title':`1. How to Start your life?`
        },
        {
            'content': [`a. By clicking Next Year, you can know this year's income. As you age, more Health may be deducted every year.`],
        },
        {
            'content': [`Industry gains money for your company every year. To buy and upgrade your industries for a higher annual profit rate.`],
        },
        {
            'content': [`b. Overview: Including the basic information of your company, you could upgrade your company to become more powerful.  `],
        },
        {
            'content': [`The industry is the core business. Try to invest them first, and there will be unexpected gains!`],
        },
        {
            'content': [`c. Estate: You can buy real estate in the market to increase your FA. It will affect the result of some events.`],
        },
        {
            'content': [`d. Garage: You can buy vehicles in the market to increse your FA. It will affect the result of some events.`],
        },
        {
            'title':`2. How to Make Good Investments?`,
        },
        {
            'content': [`a. Venture Capital: Using cash to invest in projects, and you can get profits after maturity. The final income is related to the scope of the project's income and your IQ.`],
        },
        {
            'content': [`b. The price of the stock market fluctuates every year. You can buy at low prices and sell at high prices to earn cash.`],
        },
        {
            'content': [`c. Extra deposits can be used to acquire companies, that will bring you cash dividends every year.`],
        },
        {
            'content': [`When you have over ten billion in cash, you can invest in these valuable projects. There are hundreds of millions of dividends waiting for you every year!`],
        },
        {
            'title':`3. How to Build a Strong Team?`,
        },
        {
            'content': [`a. Pay attention to the total annual salary of your staffs you've hired and their ability.`],
        },
        {
            'content': [`b. Try to refresh the market to find your favorite staff to work for you.`],
        },
        {
            'content': [`c. Poach people who already have jobs to work for you. But you need to pay a certain job-hopping fee. `],
        },
        {
            'title':`4. How to Participate in Activities?`,
        },
        {
            'content': [`a. The FS starts with 100 every year while costing you 20 FS to partake in an activity. Please don't waste them.`],
        },
        {
            'content': [`b. By doing activities, you will earn income and four-dimensional attributes (IQ, CA, EQ, FA). Or donate everything to be a charitarian.`],
        },
    ]
}
export { advanceHelp };